import { POST } from '@wellsfargo/ecpfs-authority'

export const DECLINE_TERMS_PATH = 'register/agreement/decline.json'

export function declineTerms(payload) {
	return POST(DECLINE_TERMS_PATH, payload)
}
